import { PapiEditorText, PapiOriginalsQuestion } from '@wix/da-papi-types';

export enum OriginalDeviationFieldName {
  TITLE = 'title',
  DESCRIPTION = 'description',
  MATURE_CONTENT = 'matureContent',
  NO_AI = 'noAi',
  IS_AI_GENERATED = 'isAiGenerated',
  PRICE = 'price',
  TAGS = 'tags',
  DELIVERY_TIME = 'deliveryTime',
  DISPLAY_RESOLUTION = 'displayResolution',
  ADD_WATERMARK = 'addWatermark',
  PROGRESS_IS_VISIBLE = 'progressIsVisible',
  OPEN_FOR_ORDERS = 'openForOrders',
  QUESTIONS = 'questions',
}

export interface OriginalDeviationFormFields {
  [OriginalDeviationFieldName.TITLE]: string;
  [OriginalDeviationFieldName.DESCRIPTION]: () => string;
  [OriginalDeviationFieldName.MATURE_CONTENT]: boolean;
  [OriginalDeviationFieldName.NO_AI]: boolean;
  [OriginalDeviationFieldName.IS_AI_GENERATED]: boolean;
  [OriginalDeviationFieldName.PRICE]: number;
  [OriginalDeviationFieldName.TAGS]: string[];
  [OriginalDeviationFieldName.DELIVERY_TIME]: number;
  [OriginalDeviationFieldName.DISPLAY_RESOLUTION]: number;
  [OriginalDeviationFieldName.ADD_WATERMARK]: boolean;
  [OriginalDeviationFieldName.PROGRESS_IS_VISIBLE]: boolean;
  [OriginalDeviationFieldName.OPEN_FOR_ORDERS]: boolean;
  [OriginalDeviationFieldName.QUESTIONS]: QuestionWithEditorState[];
}

export enum QuestionFieldName {
  QUESTION_BODY = 'questionBody',
  QUESTION_TYPE = 'questionType',
  ANSWER_CHOICES = 'answerChoices',
  IS_REQUIRED = 'isRequired',
}

export interface QuestionFormFields {
  [QuestionFieldName.QUESTION_BODY]: () => string;
  [QuestionFieldName.QUESTION_TYPE]: QuestionType;
  [QuestionFieldName.IS_REQUIRED]: boolean;
  [QuestionFieldName.ANSWER_CHOICES]?: AnswerChoice[];
}

export interface QuestionWithEditorState extends Omit<
  PapiOriginalsQuestion,
  'questionId' | 'position' | 'question'
> {
  questionId?: number;
  question?: PapiEditorText;
  questionEditor?: () => string;
}

export interface UnsavedQuestion extends Omit<PapiOriginalsQuestion, 'questionId' | 'position'> {
  questionId?: number;
  position?: number;
}

export type QuestionType = PapiOriginalsQuestion['type'];

export type AnswerChoice = NonNullable<PapiOriginalsQuestion['answers']>[number];
